import Avatar from "@material-ui/core/Avatar";
import Drawer from "@material-ui/core/Drawer";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import IconButton from "@material-ui/core/IconButton";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import withStyles from "@material-ui/core/styles/withStyles";
import Tooltip from "@material-ui/core/Tooltip";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import { default as classNames } from "classnames";
import get from "lodash/get";
import { withSnackbar } from "notistack";
import PropTypes from "prop-types";
import React from "react";
import { IntlProvider } from "react-intl";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";
import { bindActionCreators } from "redux";
import {
  SetClickedBreadCrum,
  SetDrawerID,
  SetMenuData,
  SetMenuList,
  SetOpenLeftDrawer,
  SetSelection,
  CommonReducerAction,
} from "../../Actions/commonAction";
import soundfile from "../../Assets/sound/sound1.mp3";
import If from "../Common/If";
import {
  LogMeOut,
  updateAuthentication,
} from "../../Actions/AuthenticationAction";
import { instance } from "../../Actions/AxiosInstance";

import { updateSubscriptionInfo } from "../../Actions/SubscriptionInfo";
import { NAVIGATION } from "../../Constants";
// import PersistentDrawerLeft from './leftmenu'
// import soundfile from "../assets/alert.mp3";
import {
  getFormattedImageLink,
  getFormattedMenuList,
  getFormattedLogoLink,
} from "../../Utils";
import { getIconFromKey } from "./icons";
import "./Navigation.css";
import Navigation1 from "./Navigation1";
import downArrow from "Assets/newicons/arrow/chevron/down/outline/chevron-down-outline-16px-white.svg";

const drawerWidth = 250;

const styles = (theme) => ({
  root: {
    // flexGrow: 1,
    // zIndex: 1,
    // overflow: 'hidden',
    position: "relative",
    // display: 'flex',
    background: "#011833",
  },
  bigAvatar: {
    width: 40,
    height: 40,
    left: 4,
    // bottom: 10
  },
  menuBar: {
    backgroundColor: theme.palette.background.default,
    padding: 0,
    width: 64,
  },
  menuItem: {
    "&:focus": {
      "& svg": {
        "& path": {
          // fill: "#166ab3"
        },
      },
      "& $primary, & $icon": {},
    },
  },
  imgBox: {
    justifyContent: "center",
    alignItems: "center",
    float: "left",
  },
  primary: {},
  icon: {},

  appBarShift: {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: drawerWidth,
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginLeft: 12,
    marginRight: 20,
  },
  hide: {
    display: "none",
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    // marginRight: -50,
    // backgroundColor: theme.palette.background.default
    backgroundColor: "#011833",
    borderRight: 0,
  },
  drawerConfig: {
    width: drawerWidth,
    flexShrink: 0,
    marginRight: -50,
    // backgroundColor: theme.palette.background.default
    backgroundColor: "#444444",
    borderRight: 0,
    position: "relative",
  },
  drawerOpenAr: {
    left: "229px",
    transition: theme.transitions.create("left", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerCloseAr: {
    left: "62px",
    transition: theme.transitions.create("left", {
      easing: theme.transitions.easing.sharp,
      duration: "200ms",
    }),
  },
  drawerOpen: {
    // width: drawerWidth,
    overflowX: "hidden",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    backgroundColor: "#011833",
    borderRight: 0,
    // position: "relative",
    // height: "100vh",
  },
  drawerOpenConfig: {
    // width: drawerWidth,
    overflowX: "hidden",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    backgroundColor: "#444444",
    borderRight: 0,
    // position: "relative",
    // paddingBottom: 56,
    // height: "100vh",
    zIndex: 1,
  },
  drawerClose: {
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: "200ms",
    }),
    overflowX: "hidden",
    // width: theme.spacing.unit * 7 + 1,
    // [theme.breakpoints.up("sm")]: {
    //   width: theme.spacing.unit * 9 + 1
    // },
    width: 64,
    backgroundColor: "#011833",
    borderRight: 0,
    position: "relative",
  },
  drawerCloseConfig: {
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: "200ms",
    }),
    overflowX: "hidden",
    // width: theme.spacing.unit * 7 + 1,
    // [theme.breakpoints.up("sm")]: {
    //   width: theme.spacing.unit * 9 + 1
    // },
    width: 250,
    backgroundColor: "#444444",
    borderRight: 0,
    position: "relative",
  },

  drawerPaper: {
    width: drawerWidth,
    paddingLeft: 64,
    backgroundColor: "#011833",
  },
  drawerHeader: {
    display: "flex",
    alignItems: "center",
    padding: "0 8px",
    ...theme.mixins.toolbar,
    justifyContent: "flex-end",
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing.unit * 3,
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: "200ms",
    }),
    marginLeft: -drawerWidth,
  },
  contentShift: {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: 0,
  },
  expand: {
    transform: "rotate(0deg)",
    transition: theme.transitions.create("transform", {
      duration: theme.transitions.duration.shortest,
    }),
    marginLeft: "auto",
    [theme.breakpoints.up("sm")]: {
      marginRight: -8,
    },
  },
  expandOpen: {
    transform: "rotate(180deg)",
  },
  slider: {
    padding: "42px 20px",
  },
  expansionPanel: {
    boxShadow: "0px 0px 0px",
    margin: 0,
    borderTopWidth: 0.5,
    borderTopColor: "#dcdcdc",
    "&$expanded": {
      margin: 0,
      borderTopWidth: 0.5,
      borderTopColor: "#dcdcdc",
      minHeight: 40,
      marginTop: 0,
      marginBottom: 0,
    },
    backgroundColor: "transparent",
  },
  navMenuSummary: {
    padding: 0,
    height: 46,
    minHeight: 46,
    marginBottom: 0,
    "&$expanded": {
      minHeight: 46,
      marginTop: 0,
      marginBottom: 0,
    },
  },
  navMenuh40: {
    height: 40,
    minHeight: 40,
    "&$expanded": {
      minHeight: 40,
    },
  },
  navMenuh0: {
    height: 0,
    minHeight: 0,
    "&$expanded": {
      minHeight: 0,
    },
  },
  dmroot: {
    boxShadow: "0px 0px 0px",
    backgroundColor: "transparent",
    margin: 0,
    padding: "8px 0",
    borderBottomLeftRadius: "0px !important",
    borderBottomRightRadius: "0px !important",
  },
  navFooter: {
    position: "fixed",
    bottom: 0,
    zIndex: 9999,
    width: 240,
    height: 110,
    marginTop: 30,
    display: "flex",
    flexDirection: "column",
  },
  navFooterCollapsed: {
    position: "fixed",
    bottom: 0,
    zIndex: 9999,
    width: 64,
    height: 110,
    marginTop: 30,
    display: "flex",
    flexDirection: "column",
  },
  h3: {
    margin: 0,
    display: "flex",
    padding: "4px 0px",
    height: 32,
    minHeight: 32,
    overflow: "visible",
    width: "100%",
    color: "#fff",
  },
  h3Div: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
  },
  h2: {
    position: "relative",
    listStyleType: "none",
    margin: 0,
    padding: "4px 0",
    width: 214,
  },
  h3Icon: {
    width: "1em",
    height: "1em",
    display: "inline-block",
    flexShrink: 0,
    margin: 4,
    // marginLeft: 8,
    fontSize: "24px",
  },
  configButton: {
    left: "12px",
    fontWeight: "bold",
    width: "106px",
    color: "#fff",
    bottom: "77px",
    position: "absolute",
    fontSize: "14px",
    marginRight: "12px",
    // position: "absolute",
    // bottom: 68,
    // // right: 0,
    // left: 8,
    // width: 106,
    // // float: "right",
    // marginRight: 12,
    // fontSize: 12,
    // // backgroundColor: "#166ab3",
    // color: "#166ab3"
  },
  toolbar1: {
    position: "fixed",
    top: 16,
    width: 24,
    height: 24,
    zIndex: 9999,
    backgroundColor: "#fff",
    color: "#011833",
    borderRadius: "50%",
    boxShadow: "0px 0px 3px #011833",
    transition: "left .2s ease",
    // left: isDrawerOpen ? 229 : 62,
    // transform: isDrawerOpen ? "scale(1,1)" : "scale(-1,1)"
  },
  colorSwitchBase: {
    color: "grey",
    "&$colorChecked": {
      color: "grey",
      "& + $colorBar": {
        backgroundColor: "grey",
      },
    },
  },
  colorBar: {},
  colorChecked: {},
  iOSSwitchBase: {
    "&$iOSChecked": {
      color: "white",
      "& + $iOSBar": {
        backgroundColor: "#52d869",
      },
    },
    transition: theme.transitions.create("transform", {
      duration: "100ms",
      easing: "50ms",
    }),
  },
  iOSChecked: {
    transform: "translateX(15px)",
    "& + $iOSBar": {
      opacity: 1,
      border: "none",
    },
  },
  iOSBar: {
    borderRadius: 13,
    width: 40,
    height: 20,
    marginTop: -11,
    marginLeft: -20,
    border: "solid 1px",
    borderColor: "transparent",
    backgroundColor: "grey",
    opacity: 1,
    transition: theme.transitions.create(["background-color", "border"]),
  },
  iOSIcon: {
    width: 24,
    height: 24,
    marginLeft: -2,
    marginTop: -2,
  },
  iOSIconChecked: {
    // boxShadow: theme.shadows[1],
    marginLeft: 0,
  },
});

class Navigation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      playsound: false,
      addClass: false,
      show: false,
      flag: true,
      anchorEl: null,
      redirect: false,
      changePassword: false,
      expanded: false,
      vacid: 1,
      flags: {
        dashboardFlag: false,
        subscriptionownerFlag: false,
        payment: false,
      },
      menuList: [],
      menuListTemp: [],
      isView: true,
      isConfig: false,
      isAction: false,
      SubscriptionData: {},
      imagepath: "",
      openParentMenuId: "",
      openParentItem: {},
      sliderValue: 0,
      showConfigOptions: false,
      selectedDrawerOption: "",
      isStopped: false,
      isPaused: false,
      open: true,
      ProfileBasicInfo: this.props.AuthenticationAction.login,
      newmenulist: [],
      configRoutesMissing: true,
    };
  }

  componentDidMount() {
    const { features } = this.props.AuthenticationAction.login;
    this.getUserInfo();
    if (window.location.pathname) {
      this.setState({
        expanded: window.location.pathname.split("/")[3]
          ? window.location.pathname
              .split("/")[3]
              .split("_")
              .join(" ")
              .replaceAll(/\w\S*/g, (x) => x[0].toUpperCase() + x.slice(1))
          : false,
      });
    }
    if (sessionStorage.getItem("appMode") == "config") {
      const [isConfigAvailable = false, newmenu = [], newmenulisticons = []] =
        getFormattedMenuList(NAVIGATION.config, features);
      this.setState({
        newmenulist: newmenu,
        configRoutesMissing: !isConfigAvailable,
      });
    } else {
      const [_, newmenu = [], newmenulisticons = []] = getFormattedMenuList(
        NAVIGATION.normal,
        features,
      );
      const [isConfigAvailable] = getFormattedMenuList(
        NAVIGATION.config,
        features,
      );
      this.setState({
        newmenulist: newmenu,
        configRoutesMissing: !isConfigAvailable,
      });
    }
  }

  getUserInfo = () => {
    const URL = "/employee/empaboutme";

    const data = {
      employeeid: get(this.props, "AuthenticationAction.login.employeeid", ""),
    };

    instance
      .post(URL, data)
      .then((result) => {
        let ProfileBasicInfo1 = [];
        result.data.result.length != 0
          ? (ProfileBasicInfo1 = result.data.result[0])
          : (ProfileBasicInfo1 = []);
        const DATA = {
          ...this.props.AuthenticationAction.login,
          ...ProfileBasicInfo1,
          imagepath:
            ProfileBasicInfo1.imagepath &&
            `${ProfileBasicInfo1.imagepath}?${Date.now()}`,
        };
        this.props.updateAuthentication("LOGIN_UPDATED_WITH_ISFULFILLED", {
          IsFulfilled: true,
          data: DATA,
        });
        this.setState({ ProfileBasicInfo: DATA });
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  };

  setDrawerOpen = (flag) => {
    // this.setState({
    //   open: flag
    // });
    this.props.SetOpenLeftDrawer(flag);
  };

  handleDrawerClose = () => {
    this.setState({ open: this.state.open, anchorEl: null });
  };

  routeUrl1 = (item) => {
    this.props.SetOpenLeftDrawer(true);
    this.props.SetDrawerID(item.id);
  };

  handleSliderChange = (event, value) => {
    this.setState({ sliderValue: value });
    // this.changeVacId(value + 1);
  };

  handleClick = (event) => {
    this.setState({ anchorEl: event.currentTarget });
    // this.setState({ show: false });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
    this.setState({ show: false });
  };

  getIcon = (path) => {
    switch (path.menuid) {
      case 19:
        return require("../../Assets/MenuIcons/Superuser/Profile.svg");
      case "a":
        return require(`./../../Assets/MenuIcons/configure-menu.svg`);
      case "b":
        return require(`./../../Assets/MenuIcons/configure-menu.svg`);
      default:
        return require(`./../../Assets/MenuIcons/configure-menu.svg`);
    }
    // let icon = require(`./../../${path}`);
    // return icon;
    // return HRISIcon;
  };

  handleExpandClick = (event, isExpanded, panel) => {
    isExpanded
      ? this.setState({ expanded: panel })
      : this.setState({ expanded: false });
  };

  getIcon2 = () => {
    // const t =
    const Temp = require(`./../../Assets/MenuIcons/configure-menu.svg`);
    return Temp;
  };

  _handleExpand = (item) => {
    // here
    this.props.SetMenuData(
      this.props.selectionReducer.menuData.map((x) => {
        if (x.menuid === item.menuid) {
          x.expanded = !x.expanded;
        }
        return x;
      }),
    );
  };

  getDrawerMenu2 = () => {
    const { classes, theme } = this.props;
    const { newmenulist, configRoutesMissing } = this.state;
    const isConfigMode = this.props.selectionReducer.appMode === "config";
    const isDrawerOpen = get(
      this.props,
      "selectionReducer.openLeftDrawer",
      true,
    );
    // const showInOpen = isDrawerOpen ? "show-div" : "show-div";
    const showInOpen = "show-div";
    const showInOpen2 = "";

    const displayNone2 = !isDrawerOpen ? "display-none-2" : "";
    // const h40 = isDrawerOpen ? 40 : 40;
    const h40 = 40;
    const navsidebarsectionHeight = isConfigMode
      ? "navsidebarsection-height1"
      : "navsidebarsection-height";
    const RedirectionMenu = ({ menu, isleaf, isroot }) =>
      isDrawerOpen ? (
        <div
          className={`${classNames(
            classes.expansionPanel,
          )} ${showInOpen2} nav-link-menu cursour-pointer`}
          style={{
            marginLeft: isleaf ? 0 : -24,
          }}
        >
          <NavLink
            to={menu.route ? menu.route : "/"}
            style={{
              display: "flex",
              fontSize: isroot ? 15 : 14,
              // paddingLeft: isleaf ? 20 : 0,
              marginLeft: -24,
              paddingLeft: 0,
              height: "100%",
              color: "rgba(255,255,255,0.7)",
            }}
            onClick={() => {
              this.routeUrl1(menu);
            }}
          >
            <Tooltip title={`${menu.featurename}`} placement="right">
              <div
                style={{
                  color:
                    menu.id ===
                    get(this.props, "selectionReducer.selectedDrawerId", "")
                      ? "#1E8CED"
                      : "rgba(255,255,255,0.7)",
                  textOverflow: "ellipsis",
                  overflow: "hidden",
                  width: "100%",
                  whiteSpace: "nowrap",
                  height: 20,
                  paddingTop: 12,
                  paddingLeft: 24,
                }}
              >
                {`${menu.featurename}`}
              </div>
            </Tooltip>
          </NavLink>
        </div>
      ) : (
        <div
          className={`${classNames(
            classes.expansionPanel,
          )} ${showInOpen2} nav-link-menu cursour-pointer`}
          style={{
            marginLeft: isleaf ? 0 : -24,
          }}
        >
          <NavLink
            to={menu.route ? menu.route : "/"}
            style={{
              display: "flex",
              fontSize: isroot ? 15 : 14,
              // paddingLeft: isleaf ? 20 : 0,
              marginLeft: -24,
              paddingLeft: 0,
              height: "100%",
              color: "rgba(255,255,255,0.7)",
            }}
            onClick={() => {
              this.routeUrl1(menu);
            }}
          >
            <Tooltip title={`${menu.featurename}`} placement="right">
              <div
                style={{
                  color:
                    menu.id ===
                    get(this.props, "selectionReducer.selectedDrawerId", "")
                      ? "#1E8CED"
                      : "rgba(255,255,255,0.7)",
                  textOverflow: "ellipsis",
                  overflow: "hidden",
                  width: "100%",
                  whiteSpace: "nowrap",
                  height: 20,
                  paddingTop: 12,
                  paddingLeft: 24,
                }}
              >
                {`${menu.featurename}`}
              </div>
            </Tooltip>
          </NavLink>
        </div>
      );

    return (
      <div
        className={`${navsidebarsectionHeight}`}
        style={{ backgroundColor: isConfigMode ? "#010709" : "#011833" }}
      >
        {newmenulist.map((rootmenu) =>
          rootmenu.value ? (
            <ExpansionPanel
              key="key"
              className={classNames(classes.expansionPanel)}
              defaultExpanded
              style={{
                padding: "4px 0px",
                marginTop: 0,
                marginBottom: 0,
              }}
              expanded={true}
            >
              <ExpansionPanelSummary
                className={`${showInOpen}`}
                style={{
                  flexDirection: "row",
                  height: h40,
                  minHeight: h40,
                }}
              >
                <div
                  style={{
                    fontSize: 16,
                    color: "#fff",
                    fontWeight: "bold",
                  }}
                >{`${rootmenu.featurename}`}</div>
              </ExpansionPanelSummary>
              <ExpansionPanelDetails
                style={{
                  padding: "0px 24px",
                }}
              >
                <div className="menuWrapper">
                  {rootmenu.value &&
                    rootmenu.value.map((navmenu) =>
                      navmenu.value ? (
                        <div key="key">
                          <ExpansionPanel
                            // defaultExpanded={isDrawerOpen ? false : true}
                            defaultExpanded={false}
                            className={classNames(classes.expansionPanel)}
                            style={{
                              borderBottom: "1px solid rgba(255,255,255,0.2)",
                              width: 202,
                            }}
                            expanded={
                              this.state.expanded === navmenu.featurename
                            }
                            onChange={(e, isexpanded) =>
                              this.handleExpandClick(
                                e,
                                isexpanded,
                                navmenu.featurename,
                              )
                            }
                          >
                            <ExpansionPanelSummary
                              className={`${showInOpen}`}
                              style={{
                                width: 202,
                                flexDirection: "row",
                                height: h40,
                                minHeight: h40,
                                padding: 0,
                              }}
                              expandIcon={<img src={downArrow}></img>}
                            >
                              <div
                                style={{
                                  fontSize: 14,
                                  color: "rgba(255,255,255,1)",
                                }}
                              >{`${navmenu.featurename}`}</div>
                              {/* <div>
                                <img src={downArrow}></img>
                              </div> */}
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails
                              style={{
                                padding: 0,
                              }}
                            >
                              <div
                                className="menuWrapper"
                                // style={
                                //   isDrawerOpen
                                //     ? {
                                //         borderLeft: "1px solid #fff",
                                //       }
                                //     : {}
                                // }
                                style={{ borderLeft: "1px solid #fff" }}
                              >
                                {navmenu.value &&
                                  navmenu.value.map((submenu) => (
                                    <RedirectionMenu menu={submenu} isleaf />
                                  ))}
                              </div>
                            </ExpansionPanelDetails>
                          </ExpansionPanel>
                        </div>
                      ) : (
                        <RedirectionMenu menu={navmenu} isroot />
                      ),
                    )}
                </div>
              </ExpansionPanelDetails>
            </ExpansionPanel>
          ) : (
            <RedirectionMenu menu={rootmenu} isroot />
          ),
        )}
      </div>
    );
  };

  render() {
    const { classes, theme } = this.props;
    const { anchorEl, configRoutesMissing } = this.state;
    const { show } = this.state;
    const anchorOpen = Boolean(anchorEl);
    const isDrawerOpen = get(
      this.props,
      "selectionReducer.openLeftDrawer",
      true,
    );
    // const showInOpen = isDrawerOpen ? "show-div" : "show-div";
    const showInOpen = "show-div";
    const displayNone2 = !isDrawerOpen ? "display-none-2" : "display-true-2";
    const tranX = isDrawerOpen ? "" : "trans-180";
    const isAdmin =
      this.props.selectionReducer.appMode != "config" && !configRoutesMissing;
    const isConfigMode = this.props.selectionReducer.appMode === "config";
    // classes
    const drawerClsObj = isConfigMode
      ? {
          [classes.drawerOpenConfig]: isDrawerOpen,
          [classes.drawerCloseConfig]: !isDrawerOpen,
        }
      : {
          [classes.drawerOpen]: isDrawerOpen,
          [classes.drawerClose]: !isDrawerOpen,
        };

    return (
      <IntlProvider locale="en" messages={null}>
        <div style={{ height: 56 }}>
          <Drawer
            variant="permanent"
            className={`config-mode-drawer ${classNames(
              classes.drawer,
              drawerClsObj,
            )}`}
            classes={{
              paper: classNames(
                isConfigMode
                  ? `${
                      isDrawerOpen ? "config-mode-paper" : "config-mode-paper1"
                    }`
                  : "normal-mode-paper",
              ),
            }}
            open={isDrawerOpen}
            style={{ backgroundColor: isConfigMode ? "#010709" : "#011833" }}
          >
            {/** Header */}
            <If condition={false /*! isConfigMode */}>
              <div className={classNames(classes.toolbar)}>
                <MenuItem className={classNames(classes.imgBox, "nav-logo")}>
                  <img
                    src={getFormattedLogoLink(
                      get(
                        this.props,
                        "SubscriptionInfo.SubscriptionData.logo",
                        "",
                      ),
                    )}
                    alt="icon"
                    height="40"
                    width="40"
                  />
                </MenuItem>
                <div
                  style={{
                    paddingTop: 23,
                    color: "#fff",
                    fontSize: 16,
                    float: "left",
                    width: "60%",
                    textOverflow: "ellipsis",
                    overflow: "hidden",
                  }}
                  className={`${showInOpen} ${displayNone2}`}
                >
                  {
                    get(
                      this.props,
                      "SubscriptionInfo.SubscriptionData.subscriptionname",
                      "_ _",
                    ).split(" ")[0]
                  }
                </div>
              </div>
            </If>

            {/** menus */}

            {isConfigMode ? this.getDrawerMenu2() : <Navigation1 />}
            {/** Bottom */}
            <If condition={false /*! isConfigMode */}>
              <div
                className={`${
                  isDrawerOpen
                    ? classNames(classes.navFooter)
                    : classNames(classes.navFooterCollapsed)
                }`}
              >
                <If condition={isAdmin}>
                  <div
                    className={`${showInOpen}`}
                    style={{
                      display: "flex",
                      height: 50,
                      backgroundColor: "rgba(26, 43, 65)",
                      borderBottom: "1px solid rgba(255, 255, 255, 0.2)",
                      cursor: "pointer",
                    }}
                  >
                    <div
                      disabled
                      className={`${classNames(
                        classes.configButton,
                      )} ${showInOpen}`}
                      unelevated
                    >
                      Config Mode
                    </div>
                    <NavLink
                      className={`${showInOpen} ${displayNone2}`}
                      style={{
                        float: "right",
                        position: "absolute",
                        right: 13,
                        marginTop: 13,
                      }}
                      to="/config/dashboard"
                      target="_blank"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="#fff"
                      >
                        <path d="M0 0h24v24H0z" fill="none" />
                        <path d="M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z" />
                      </svg>
                    </NavLink>
                  </div>
                </If>

                <div className={`config-switch`}>
                  <IconButton
                    style={{ position: "relative !important", padding: 8 }}
                    className="profile-button"
                    aria-label="More"
                    aria-owns={anchorOpen ? "long-menu" : null}
                    aria-haspopup="true"
                    onClick={this.handleClick}
                  >
                    <div className={classNames(classes.row)}>
                      <Avatar
                        alt="Profile Image"
                        src={getFormattedImageLink(
                          `${get(
                            this.state,
                            "ProfileBasicInfo.imagepath",
                            "",
                          )}`,
                        )}
                        // src={get(this.props.AuthenticationAction, "login.imagepath", "")}
                        className={classNames(
                          classes.avatar,
                          classes.bigAvatar,
                        )}
                      />
                    </div>
                    <div
                      className={`${showInOpen} ${displayNone2}`}
                      style={{ paddingLeft: 16 }}
                    >
                      <div className="t-16 text-align-left text-color-white letter-spacing0">
                        {`${get(
                          this.props.AuthenticationAction,
                          "login.fullname",
                          "",
                        )}`}
                      </div>
                      <div
                        className="t-12 text-align-left text-color-white"
                        style={{ letterSpacing: 0 }}
                      >
                        {get(
                          this.state,
                          "ProfileBasicInfo.designationname",
                          "",
                        )}
                      </div>
                    </div>
                  </IconButton>
                </div>

                <div>
                  <Menu
                    id="long-menu"
                    anchorEl={anchorEl}
                    anchorReference="anchorPosition"
                    anchorPosition={
                      get(this.props, "selectionReducer.openLeftDrawer", false)
                        ? { top: 1400, left: 260 }
                        : { top: 1400, left: 90 }
                    }
                    open={anchorOpen}
                    onClose={this.handleClose}
                  >
                    <MenuItem onClick={() => this.setState({ anchorEl: null })}>
                      <NavLink
                        className="secondary-color"
                        to="/change_password"
                      >
                        Update Password
                      </NavLink>
                    </MenuItem>
                    <MenuItem
                      onClick={() =>
                        this.props.LogMeOut(
                          get(
                            this.props,
                            "AuthenticationAction.login.userid",
                            "",
                          ),
                        )
                      }
                    >
                      Logout
                    </MenuItem>
                  </Menu>
                </div>
              </div>
            </If>
          </Drawer>
          <div
            className={classNames(classes.content, {
              [classes.contentShift]:
                show &&
                this.state.openParentMenuId ===
                  this.props.selectionReducer.globalSelection,
            })}
          />
        </div>
      </IntlProvider>
    );
  }
}

Navigation.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  AuthenticationAction: state.AuthenticationAction,
  SubscriptionInfo: state.SubscriptionInfo,
  selectionReducer: state.selectionReducer,
  FCMReducer: state.FCMReducer,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      LogMeOut,
      updateAuthentication,
      CommonReducerAction: (type, data) => CommonReducerAction(type, data),
      SetSelection: (d) => SetSelection(d),
      SetDrawerID: (dt) => SetDrawerID(dt),
      updateSubscriptionInfo: (type, payload) =>
        updateSubscriptionInfo(type, payload),
      SetMenuList,
      SetMenuData,
      SetClickedBreadCrum,
      SetOpenLeftDrawer,
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles, { withTheme: true })(withSnackbar(Navigation)));
